import styled from 'styled-components';

import { InfoTitle } from '../../../../components/Toolkit/InfoTitle/InfoTitle';

import { media } from '../../../../helpers/breakpoints';

export const Header = styled(InfoTitle)`
  margin-bottom: ${({ theme }) => theme.spacing.M24};
  ${media.medium} {
    padding: 0;
    width: 544px;
  }
`;

export const CardsContainer = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const Card = styled.li<{ count: number }>`
  width: 100%;
  margin-bottom: ${({ theme, count }) => (count > 1 ? theme.spacing.M24 : '')};
  &:last-child {
    margin-bottom: 0;
  }

  ${media.large} {
    height: 420px;
    width: 220px;
    margin: ${({ theme }) => `0 ${theme.spacing.S12} 0 ${theme.spacing.S12}`};
  }
`;
